import { array, assign, literal, number, object, string } from "superstruct";

import { SPENDING_RULES_REWARD_TYPES } from "../constants";

const RewardsSpendingRuleRewardBaseSchema = object({
    templateId: string(),
    versionId: string(),
    expirationInDays: number(),
});

export const RewardsSpendingRuleFixedAmountRewardSchema = assign(
    RewardsSpendingRuleRewardBaseSchema,
    object({
        rewardType: literal(SPENDING_RULES_REWARD_TYPES.fixedAmountDiscount),
        amount: number(),
        minOrderPrice: number(),
    })
);

export const RewardsSpendingRuleFlexibleAmountRewardSchema = assign(
    RewardsSpendingRuleRewardBaseSchema,
    object({
        rewardType: literal(SPENDING_RULES_REWARD_TYPES.flexibleAmountDiscount),
        everyX: number(),
        amountY: number(),
        minOrderPrice: number(),
        maxCoveragePercents: number(),
    })
);

export const RewardsSpendingRuleFixedPercentageRewardSchema = assign(
    RewardsSpendingRuleRewardBaseSchema,
    object({
        rewardType: literal(
            SPENDING_RULES_REWARD_TYPES.fixedPercentageDiscount
        ),
        percents: number(),
        minOrderPrice: number(),
    })
);

export const RewardsSpendingRuleFlexiblePercentageRewardSchema = assign(
    RewardsSpendingRuleRewardBaseSchema,
    object({
        rewardType: literal(
            SPENDING_RULES_REWARD_TYPES.flexiblePercentageDiscount
        ),
        everyX: number(),
        percentsY: number(),
        minOrderPrice: number(),
    })
);

export const RewardsSpendingRuleGiftCardRewardSchema = assign(
    RewardsSpendingRuleRewardBaseSchema,
    object({
        rewardType: literal(SPENDING_RULES_REWARD_TYPES.giftCard),
        initialValue: number(),
    })
);

export const RewardsSpendingRuleFreeShippingRewardSchema = assign(
    RewardsSpendingRuleRewardBaseSchema,
    object({
        rewardType: literal(SPENDING_RULES_REWARD_TYPES.shippingDiscount),
        countryCodes: array(string()),
        minOrderPrice: number(),
        maxShippingPrice: number(),
    })
);

export const RewardsSpendingRuleProductRewardSchema = assign(
    RewardsSpendingRuleRewardBaseSchema,
    object({
        rewardType: literal(SPENDING_RULES_REWARD_TYPES.productDiscount),
        productId: number(),
        variantId: number(),
        percents: number(),
        minOrderPrice: number(),
    })
);

export const RewardsSpendingRuleStoreCreditRewardSchema = assign(
    RewardsSpendingRuleRewardBaseSchema,
    object({
        rewardType: literal(SPENDING_RULES_REWARD_TYPES.fixedStoreCredit),
        amount: number(),
    })
);
